import { createContext, useState, useContext } from 'react';
import API from '../services/api';

const DatabaseContext = createContext();

export const useDatabases = () => useContext(DatabaseContext);

export const DatabaseProvider = ({ children }) => {
  const [databases, setDatabases] = useState([]);
  
  const refreshDatabases = async () => {
    try {
      const response = await API.get('/api/databases?page=0&limit=1000');
      setDatabases(response.data.databases);
    } catch (error) {
      console.error('Error loading databases', error);
    }
  };

  return (
    <DatabaseContext.Provider value={{ databases, refreshDatabases }}>
      {children}
    </DatabaseContext.Provider>
  );
};
